import React from 'react';
import ReactDOM from 'react-dom';

import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { Form, Input, Button, Typography } from 'antd';

import { api } from '@app/api';
import { useApi } from '@app/api/useApi';

type LoginFormValues = {
    email: string;
    password: string;
};

const LoginForm = () => {
    const [{ loading, error }, login] = useApi(api.auth.login, null, { manual: true });

    const onFinish = (values: LoginFormValues) => {
        login({ loginCredentials: { username: values.email, password: values.password } }).then(([, err]) => {
            if (!err) {
                window.location.assign(window.location.origin);
            }
        });
    };

    return (
        <Form<LoginFormValues> className="login-form" initialValues={{ remember: true }} onFinish={onFinish}>
            <Form.Item style={{ textAlign: 'center' }}>
                <Typography.Title level={2}>REGUZA</Typography.Title>
                <Typography.Text>Prosím přihlašte se</Typography.Text>
            </Form.Item>
            <Form.Item name="email" rules={[{ required: true, message: 'Zadejte email' }, { type: 'email' }]}>
                <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="Email" />
            </Form.Item>
            <Form.Item name="password" rules={[{ required: true, message: 'Zadejte heslo' }]}>
                <Input.Password prefix={<LockOutlined className="site-form-item-icon" />} placeholder="Heslo" />
            </Form.Item>
            {error && (
                <Form.Item style={{ textAlign: 'center' }}>
                    <div className="ant-form-item-explain ant-form-item-explain-error">
                        <div role="alert">Neplatný email nebo heslo.</div>
                    </div>
                </Form.Item>
            )}
            <Form.Item>
                <Button type="primary" htmlType="submit" className="login-form-button" loading={loading}>
                    Přihlásit
                </Button>
            </Form.Item>
        </Form>
    );
};

ReactDOM.render(<LoginForm />, document.getElementById('root'));
